import {IServices} from '../../../../../common/ts/core/services/Services';
import InvoiceService from './InvoiceService';

export default function registerServices(services: IServices) {
    services.singleton('InvoiceService', InvoiceService);
}